/**
 * Centralized navigation + API error logger.
 * Captures navigation events and API errors for debugging "random jumps" on native.
 */

interface NavLogEntry {
  ts: number;
  type: "nav" | "api_error" | "auth_event" | "error";
  from?: string;
  to?: string;
  detail?: string;
}

const MAX_LOG_ENTRIES = 100;
const navLog: NavLogEntry[] = [];

export function logNav(from: string, to: string) {
  push({ ts: Date.now(), type: "nav", from, to });
}

export function logApiError(endpoint: string, detail: string) {
  push({ ts: Date.now(), type: "api_error", detail: `${endpoint}: ${detail}` });
}

export function logAuthEvent(detail: string) {
  push({ ts: Date.now(), type: "auth_event", detail });
}

export function logError(detail: string) {
  push({ ts: Date.now(), type: "error", detail });
}

function push(entry: NavLogEntry) {
  navLog.push(entry);
  if (navLog.length > MAX_LOG_ENTRIES) navLog.shift();
  // Also emit to console for live debugging
  console.log(`[NavLog] ${entry.type}`, entry);
}

/** Return recent entries for diagnostics */
export function getNavLog() {
  return [...navLog];
}

/** Expose on window for debug console access */
if (typeof window !== "undefined") {
  (window as any).__getNavLog = getNavLog;
}
